// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfWeek as fn } from "../startOfWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfWeek = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfWeek;
